export default __webpack_public_path__ + "static/media/tamer-emara-b.59976cea.jpg";